import { type ReactNode } from 'react';
import { StandardProfileLink } from '@components/StandardProfileLink';
import { type ZoneModels } from '@models/Zone';
import { simplePluralize } from '@utils/stringFormatUtils';

interface LinkToRequirementsProps {
    profile: ZoneModels.StandardProfile;
    standard: ZoneModels.Standard;
    requirementCount: number;
    zoneId?: string;
    projectId?: string;
}

export function LinkToRequirements(params: LinkToRequirementsProps): ReactNode {
    const { profile, requirementCount, zoneId, projectId } = params;

    return (
        <StandardProfileLink
            profile={profile}
            label={`View ${requirementCount} ${simplePluralize('requirement', requirementCount)}`}
            openInNewTab
            zoneId={zoneId}
            projectId={projectId}
        />
    );
}
